import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 fw-bold gy-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Toplam Adedi ", -1)
const _hoisted_7 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Toplam Sevk Miktarı ", -1)
const _hoisted_9 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Toplam Fiyat ", -1)
const _hoisted_11 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Toplam Sevk Tutarı ", -1)
const _hoisted_13 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Birim Fiyat ", -1)
const _hoisted_15 = {
  colspan: "3",
  class: "text-start text-muted fw-bolder fs-7 gs-0"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sevk Tarihi ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Yükleme Tarihi ", -1)
const _hoisted_18 = {
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4",
  id: "kt_subscription_products_table"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Beden"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sipariş Adedi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilmiş"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilmeyen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Neden"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Toplam Tutar")
  ])
], -1)
const _hoisted_20 = { class: "text-gray-600" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

import { ref, withDefaults } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import DifferenceReason from "@/components/differenceReasons/DifferenceReason.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import { useRouter, useRoute } from "vue-router";
import useNotification from "@/components/useNotification";

import moment from "moment";
export interface PropsModel {
  id: number;
  isActive: boolean;
  shippingDetail: any;
  sizeRows: any;
  data: any;
  orderId: number;
  order: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddShipping',
  props: {
    id: { default: 0 },
    isActive: { type: Boolean, default: false },
    shippingDetail: { default: null },
    sizeRows: { default: null },
    data: { default: null },
    orderId: { default: 0 },
    order: { default: null }
  },
  emits: ["changeAddShipping"],
  setup(__props: any, { emit }) {

const props = __props as { id: number, isActive: boolean, shippingDetail: any, sizeRows: any, data: any, orderId: number, order: any }

const router = useRouter();
const route = useRoute();
const updateButtonDisabled = ref(false);

const notification = useNotification();

const toast = useToast();
const store = useStore();
const shippingDate = ref(props.data?.shippingDate);
const orderShippingDate = ref(
  moment(store.state.OrderModule.order.value.estimatedShippingDate).format(
    "yyyy-MM-DD"
  )
);

const isActive = ref(props.isActive);

const toggleModal = () => {
  isActive.value = !isActive.value;
};
store.dispatch(Actions.DELIVERY_LINE_LIST, props.id);

const onChange = (args) => {
  emit("changeAddShipping", args);
};
const saveChanges = () => {
  isDisabled.value = true;
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  var model = {
    orderId: route.params?.id,
    shippingDate: shippingDate.value,
    OrderShippingDate: orderShippingDate.value,
    orderLineId: props.shippingDetail.id,
    unitPrice: parseFloat(props.shippingDetail.price),
    orderQuantity: props.shippingDetail.totalQuantity,
    deliveryLines: props.shippingDetail.orderDetails.map((f) => {
      return {
        orderDetailId: f.id,
        shippingQuantity:
          f.shippedQuantity != null ? parseInt(f.shippingQuantity) : 0,
        differenceReasonId:
          reasons.value.length > 0
            ? reasons.value.find((a) => a.orderDetailId == f.id)?.Id
            : null,
      };
    }),
  };
  console.log(store.state.OrderModule.order.value.orderLines);
  console.log(props.shippingDetail.orderDetails);
  if (!model.shippingDate) {
    error("Sevk tarihi seçilmelidir!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    isDisabled.value = false;
    return;
  }
  if (!model.shippingDate) {
    error("Yükleme tarihi seçilmelidir!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    isDisabled.value = false;
    return;
  }
  store.dispatch(Actions.ADD_DELIVERY, model).then((f) => {
    if (f.success) {
      store.dispatch(
        Actions.ORDER_DETAIL,
        store.state.OrderModule.order.value.id
      );
      if (f.success && !f.warning) {
        success(f.message);
      } else if (f.warning) {
        isDisabled.value = false;
        notification.showWarning(f.message);
      } else {
        notification.showError(f.message);
        isDisabled.value = false;
      }
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    } else {
      notification.showError(f.message);
      isDisabled.value = false;
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    }
  });
};
const reasonId = ref();
const reasons: any = ref([]);
const selectedDifferenceReason = (args) => {
  if (!args) {
    alert(1);
  } else {
    reasonId.value = args.value;
  }
};
const ali = (item) => {
  var model = {
    Id: reasonId.value,
    orderDetailId: item.id,
  };
  reasons.value.push(model);
  console.log(reasons.value);
};
const success = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const warning = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "warning",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const error = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const isDisabled = ref(false);

const onKeyup = (event) => {
  const next = event.target.getAttribute("sequence");
  let index = parseInt(next) + 1;
  if (
    event.keyCode == 13 ||
    event.keyCode == 81 ||
    event.keyCode == 32 ||
    event.keyCode == 9
  ) {
    document.getElementsByName("orderLinePrice-" + index)[0].select();
    document.getElementsByName("orderLinePrice-" + index)[0].focus();
  }
};
const nextField = (current) => {
  alert(current);
  for (let i = 0; i < current.form.elements.length; i++) {
    if (current.form.elements[i].tabIndex - current.tabIndex == 1) {
      current.form.elements[i].focus();
      if (current.form.elements[i].type == "text") {
        current.form.elements[i].select();
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(Modal, {
    onClose: onChange,
    modalActive: props.isActive,
    title: "Yeni Sevkiyat",
    closeIcon: false,
    width: "75vw"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Kaydet",
        type: "button",
        icon: "pi pi-check",
        disabled: isDisabled.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (saveChanges()))
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_6,
                    _createElementVNode("td", _hoisted_7, _toDisplayString(props.shippingDetail.totalQuantity), 1),
                    _hoisted_8,
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                        .find((f) => f.id == props.shippingDetail.id)
                        .deliveries.map((f) => f.totalQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    _createElementVNode("td", _hoisted_11, _toDisplayString(props.shippingDetail.totalPrice) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1),
                    _hoisted_12,
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                        .find((f) => f.id == props.shippingDetail.id)
                        .deliveries.map((f) => parseFloat(f.totalPrice))
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                        .toFixed(2)) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, _toDisplayString(props.shippingDetail.price) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingDate).value = $event)),
                        autofocus: "",
                        required: ""
                      }, null, 512), [
                        [_vModelText, shippingDate.value]
                      ])
                    ]),
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderShippingDate).value = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, orderShippingDate.value]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.OrderModule.order.value.orderLines.find(
                    (f) => f.id == props.shippingDetail.id
                  ).orderDetails, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "odd",
                      key: index
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.size.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                      _createElementVNode("td", null, _toDisplayString(item.shippedQuantity), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(), _createBlock(_unref(Field), {
                          type: "text",
                          class: "form-control form-control-solid",
                          name: 'orderLinePrice-' + index,
                          ref_for: true,
                          ref: "test",
                          sequence: index,
                          key: index,
                          tabindex: 0,
                          modelValue: 
                        _unref(store).state.OrderModule.order.value.orderLines
                          .find((f) => f.id == props.shippingDetail.id)
                          .orderDetails.find((x) => x.id == item.id)
                          .shippingQuantity
                      ,
                          "onUpdate:modelValue": ($event: any) => ((
                        _unref(store).state.OrderModule.order.value.orderLines
                          .find((f) => f.id == props.shippingDetail.id)
                          .orderDetails.find((x) => x.id == item.id)
                          .shippingQuantity
                      ) = $event)
                        }, null, 8, ["name", "sequence", "modelValue", "onUpdate:modelValue"]))
                      ]),
                      (item.quantity - item.shippedQuantity > 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(item.quantity - item.shippedQuantity), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_22, "0")),
                      _createElementVNode("td", null, [
                        _createVNode(DifferenceReason, {
                          onChangeDifferenceReason: selectedDifferenceReason,
                          onChange: ($event: any) => (ali(item)),
                          tabindex: index
                        }, null, 8, ["onChange", "tabindex"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString((
                        parseFloat(
                          props.shippingDetail.price.replace(",", ".")
                        ) * item.shippingQuantity
                      ).toFixed(2)) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})